module.exports = __webpack_public_path__ + "img/ruleEngine.09669408.jpg";